/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Probe outcome.
 */
export const ProbeURLResultOutcome = {
  McpAvailable: "mcp_available",
  AuthenticationRequired: "authentication_required",
  InvalidMcpResponse: "invalid_mcp_response",
  Unreachable: "unreachable",
} as const;
/**
 * Probe outcome.
 */
export type ProbeURLResultOutcome = ClosedEnum<typeof ProbeURLResultOutcome>;

/**
 * Structured outcome of probing a remote MCP server URL. Variant-specific fields are populated only when applicable.
 */
export type ProbeURLResult = {
  /**
   * HTTP status returned by the remote server. Required for invalid_mcp_response and present for HTTP-based unreachable outcomes.
   */
  httpStatus?: number | undefined;
  /**
   * Probe outcome.
   */
  outcome: ProbeURLResultOutcome;
  /**
   * Absolute HTTP(S) protected resource metadata URL advertised by a WWW-Authenticate challenge. Present only when authentication is required and the advertised URL is valid.
   */
  protectedResourceMetadataUrl?: string | undefined;
  /**
   * Stable machine-readable reason code. Present only when outcome is unreachable; currently timeout, rate_limited, server_error, dns_error, tls_error, guardian_rejected, or transport_error.
   */
  reason?: string | undefined;
};

/** @internal */
export const ProbeURLResultOutcome$inboundSchema: z.ZodMiniEnum<
  typeof ProbeURLResultOutcome
> = z.enum(ProbeURLResultOutcome);

/** @internal */
export const ProbeURLResult$inboundSchema: z.ZodMiniType<
  ProbeURLResult,
  unknown
> = z.pipe(
  z.object({
    http_status: z.optional(z.int()),
    outcome: ProbeURLResultOutcome$inboundSchema,
    protected_resource_metadata_url: z.optional(z.string()),
    reason: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "http_status": "httpStatus",
      "protected_resource_metadata_url": "protectedResourceMetadataUrl",
    });
  }),
);

export function probeURLResultFromJSON(
  jsonString: string,
): SafeParseResult<ProbeURLResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ProbeURLResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ProbeURLResult' from JSON`,
  );
}
